<template>
  <div id="basic-insert-data">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="insert-data-container">
            <div class="input-area">
              <span class="title">新規{{masterName}}登録</span>

              <div class="input-row" v-for="(inputType, index) in inputTypes" :key="index">
                
                <div class="color-input" v-if="inputType.inputType == 'color'">
                  <span class="label">{{inputType.label}}</span>
                  <editable-color-cell
                    :isEditing="true"
                    :color="colorOptions[0]"
                    @updateValue="updateValue(index, $event)"
                    :colorOptions="colorOptions"
                  >
                  </editable-color-cell>
                </div>

                <div class="string-input" v-if="inputType.inputType == 'string'">
                  <div class="label">
                    <span>{{inputType.label}}</span>
                    <span v-if="inputType.hasOwnProperty('regex')" class="validation-label">*</span>
                  </div>
                  <vs-input
                    :class="inputType.key + '-input'"
                    color="#2D9CDB"
                    v-model="inputValues[index].value"
                  >
                  </vs-input>
                </div>

                <div class="select-input" v-if="inputType.inputType == 'select'">
                  <span class="label">{{inputType.label}}</span>
                  <editable-select-cell
                    :isEditing="true"
                    :selectOptions="inputType.selectOptions"
                    @updateValue="updateValue(index, $event)"
                    v-if="inputType.selectOptions.length != 0"
                    :value="String(inputType.selectOptions[0].id)"
                  >
                  </editable-select-cell>
                </div>

                <div class="text-area-input" v-if="inputType.inputType == 'textArea'">
                  <span class="label">{{inputType.label}}</span>
                  <editable-text-area-cell
                    :isEditing="true"
                    @updateValue="updateValue(index, $event)"
                  >
                  </editable-text-area-cell>
                </div>

              </div>
              <div class="button-area">
                <vs-button class="cancel-button" color="#BDBDBD" :to="{name: backTo}">キャンセル</vs-button>
                <vs-button :disabled="!activeInsertButton" class="insert-button" color="#2D9CDB" @click="clickInsertButton">登録</vs-button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <error-dialog
      ref="errorDialog"
    ></error-dialog>
  </div>
</template>

<script>

import EditableColorCell from "./EditableColorCell";
import EditableSelectCell from "./EditableSelectCell";
import EditableTextAreaCell from "./EditableTextAreaCell";
import ErrorDialog from "./ErrorDialog";

export default {
  components: {
    EditableColorCell,
    EditableSelectCell,
    EditableTextAreaCell,
    ErrorDialog
  },
  props: {
    masterName: { type: String },
    backTo: { type: String },
    inputTypes: { type: Array },
    colorOptions: { type: Array },
  },
  data() {
    return {
      inputValues: this.inputTypes.map(element => {
        return {
          key: element.key,
          value: ""
        }
      }),
      activeInsertButton: true,
    }
  },
  created() {
  },
  watch: {
    inputValues: {
      handler: function(){
        let inputTypesWithRegex = this.inputTypes.filter((value) => Object.prototype.hasOwnProperty.call(value, "regex"))
        if (inputTypesWithRegex.length == 0) {
          this.activeInsertButton = true
        } else {
          let passRegex = inputTypesWithRegex.every((value, index) => this.inputValues[index].value.match(value.regex))
          this.activeInsertButton = passRegex
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateValue(index, value) {
      this.inputValues[index].value = value
    },
    clickInsertButton() {
      this.$emit("insertData", this.inputValues)
    },
    openErrorPopup(title, errorMessage, validationErrors) {
      this.$refs.errorDialog.open(title, errorMessage, validationErrors)
    },
  }
}
</script>

<style lang="scss" scoped>
.insert-data-container {
  display: flex;
  justify-content: space-between;
}
.title {
  font-size: 18px;
}
.input-row {
  margin: 20px 0px;
}
.string-input, .color-input, .select-input, .text-area-input {
  display: flex;
  align-items: center;
}
.label {
  width: 110px;
}
.validation-label {
  color: red;
  margin-left: 4px;
}
.button-area {
  margin-top: 30px;
  .insert-button {
    margin-left: 10px;
  }
}

</style>
